import { dataZoomOut } from 'dls-icons-data'
import { createIcon } from '../common'

const IconZoomOut = /*#__PURE__*/createIcon(dataZoomOut)
export default IconZoomOut
